import FetchService from "./Shared/FetchService";
import ActivityItemService from "../Domain/ActivityItem/ActivityItem.service";
import ItemUpdateService from "../Domain/ItemUpdate/ItemUpdate.service";
import ItemEventReplyDomainService from "../Domain/ItemEventReply/ItemEventReply.service";
const baseURL = "/aviso/activity";
export default class ActivityService {
    static comment(activityItemTypeId, activityItemId, text) {
        return FetchService.postSingleResponse(baseURL + "/comment", {
            activityItemTypeId,
            activityItemId,
            text,
        });
    }
    static editItemEvent(itemEventId, newText) {
        return FetchService.postSingleResponse(baseURL + "/editItem", {
            value: newText,
            itemEventId,
            // @ts-expect-error - TS2345 - Argument of type '(json: { [key: string]: any; }) => ItemUpdate' is not assignable to parameter of type '(value: unknown) => ItemUpdate | PromiseLike<ItemUpdate>'.
        }).then(ItemUpdateService.fromJSON);
    }
    static deleteItemEvent(itemEventId) {
        return FetchService.postSingleResponse(baseURL + "/deleteItem", {
            itemEventId,
        });
    }
    static replyToEvent(itemEventId, reply) {
        return FetchService.postSingleResponse(baseURL + "/replyToItemEvent", {
            itemEventId,
            value: reply,
            // @ts-expect-error - TS2345 - Argument of type '(json: { [key: string]: any; }) => ItemEventReply' is not assignable to parameter of type '(value: unknown) => ItemEventReply | PromiseLike<ItemEventReply>'.
        }).then(ItemEventReplyDomainService.fromJSON);
    }
    static editReply(itemEventReplyId, newText) {
        return FetchService.postSingleResponse(baseURL + "/editReply", {
            itemEventReplyId,
            value: newText,
            // @ts-expect-error - TS2345 - Argument of type '(json: { [key: string]: any; }) => ItemEventReply' is not assignable to parameter of type '(value: unknown) => ItemEventReply | PromiseLike<ItemEventReply>'.
        }).then(ItemEventReplyDomainService.fromJSON);
    }
    static deleteReply(itemEventReplyId) {
        return FetchService.postSingleResponse(baseURL + "/deleteReply", {
            itemEventReplyId,
        });
    }
    static commentSync(activityItemTypeId, activityItemId, text) {
        const id = typeof activityItemId === "string"
            ? { activityItemIdUUID: activityItemId }
            : { activityItemId };
        return FetchService.postSingleResponse(baseURL + "/commentSync", Object.assign(Object.assign({ activityItemTypeId }, id), { text })).then(ItemUpdateService.fromJSON);
    }
    static searchActivityItems(searchObject, options) {
        return FetchService.getSingleResponse(baseURL + "/searchActivityItems", Object.assign({ search: JSON.stringify(searchObject) }, options)).then((resp) => {
            var _a;
            return (Object.assign(Object.assign({}, resp), { 
                // @ts-expect-error - TS2571 - Object is of type 'unknown'. | TS7006 - Parameter 'item' implicitly has an 'any' type.
                items: (_a = resp === null || resp === void 0 ? void 0 : resp.items) === null || _a === void 0 ? void 0 : _a.map((item) => ({
                    updates: item.updates.map(ItemUpdateService.fromJSON),
                    activityItem: ActivityItemService.fromJSON(item.activityItem),
                })) }));
        });
    }
    static searchItemUpdates(searchObject, options) {
        return FetchService.getSingleResponse(baseURL + "/searchUpdates", Object.assign({ search: JSON.stringify(searchObject) }, options)).then((resp) => (Object.assign(Object.assign({}, resp), { 
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            updates: (resp.updates || []).map(ItemUpdateService.fromJSON) })));
    }
    static getActivityItem(activityItemTypeId, 
    /**
     * TODO make this optional and add in itemIdUUID
     */
    itemIdInt) {
        return FetchService.getSingleResponse(baseURL + "/getActivityItem", {
            activityItemTypeId,
            itemIdInt,
            // @ts-expect-error - TS2345 - Argument of type '(activityItem: { [key: string]: any; }) => ActivityItem' is not assignable to parameter of type '(value: unknown) => ActivityItem | PromiseLike<ActivityItem>'.
        }).then(ActivityItemService.fromJSON);
    }
    static getActivityItemEvents(activityItemTypeId, itemIdInt) {
        return FetchService.getSingleResponse(baseURL + "/getActivityItemEvents", {
            activityItemTypeId,
            itemIdInt,
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        }).then((items) => items.map(ItemUpdateService.fromJSON));
    }
    static searchItemStatuses(activityItemTypeIds) {
        return FetchService.getSingleResponse(baseURL + "/searchItemStatuses", {
            activityItemTypeIds,
        });
    }
    static areThereRecentEventsForPerson(personId) {
        return FetchService.getSingleResponse(baseURL + "/areThereRecentEventsForPerson", {
            personId,
        });
    }
    static getEnabledFilters(personTypeName) {
        return FetchService.getSingleResponse(baseURL + "/getEnabledFilters", {
            personTypeName,
        });
    }
    static getEnabledFiltersForContextPerson(personId, personTypeName) {
        return FetchService.getSingleResponse(baseURL + "/getEnabledFiltersForContextPerson", { personId, personTypeName });
    }
    static canAccessActivityFeed(filterId) {
        return FetchService.getSingleResponse(baseURL + "/canAccessActivityFeed", {
            filterId,
        });
    }
}
